const isProntoPagaPaymentMethod = (handler: string) => {
  return `${handler}`.includes('ProntoPaga');
};

export default isProntoPagaPaymentMethod;
